import { useSelector } from 'react-redux';
import { NodeType } from '../types/uncinc_profile/nodes';

export default function useCurrentNodeType() {
  const currentEntityId: string = useSelector<Immutable.Map<any, any>>((state) => state.getIn(['entity', 'entityId'], null)) as string;

  const currentNodeType: NodeType | undefined = useSelector<Immutable.Map<any, any>>((state) => state.getIn(['node', currentEntityId, 'type', 0, 'target_id'])) as NodeType | undefined;

  return {
    currentNodeType,
  } as const;
}
